import React, { useState, useEffect, useMemo } from 'react';
import {
  FaArrowRight,
  FaStar,
  FaFire,
  FaGlasses,
  FaSun,
  FaEye,
  FaChild,
  FaTag,
  FaBolt,
  FaTimes,
  FaShoppingCart,
  FaHeart,
  FaRegHeart,
  FaCreditCard,
  FaTruck,
  FaCheckCircle,
  FaStore,
  FaCube,
  FaRegEye,
  FaCamera,
  FaUser,
  FaQuestionCircle,
  FaChevronDown,
  FaChevronUp,
  FaStarHalfAlt,
  FaGift,
  FaPercentage,
  FaRupeeSign,
  FaShieldAlt,
  FaExchangeAlt
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const TopCategories = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [wishlist, setWishlist] = useState(false);
  const [pincode, setPincode] = useState('');
  const [deliveryChecked, setDeliveryChecked] = useState(false);
  const [selectedSize, setSelectedSize] = useState('M');
  const [selectedColor, setSelectedColor] = useState(0);
  const [activeImage, setActiveImage] = useState(0);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [showFullReviews, setShowFullReviews] = useState(false);
  const navigate = useNavigate();

  const iconMap = useMemo(() => ({
    glasses: <FaGlasses />,
    sun: <FaSun />,
    bolt: <FaBolt />,
    eye: <FaEye />,
    child: <FaChild />,
    tag: <FaTag />,
  }), []);

  const categories = useMemo(() => ([
    {
      id: 1,
      name: 'EYEGLASSES',
      image: 'https://img.freepik.com/premium-photo/black-frame-eyeglasses-unisex-isolated-white-background_727279-100.jpg?w=740',
      count: '1240+',
      iconName: 'glasses',
      price: '₹2,999',
      originalPrice: '₹4,999',
      discount: '40%',
      rating: 4.5,
      reviews: 1240,
      description: 'Premium quality eyeglasses with anti-glare coating',
      highlights: ['Anti-glare coating', 'Blue cut', 'Lightweight', 'Durable frame']
    },
    {
      id: 2,
      name: 'SUNGLASSES',
      image: 'https://img.gkbcdn.com/p/2018-12-24/round-metal-sunglasses-gold-and-brown-1571970449419._w315_.jpg',
    
      count: '850+',
      iconName: 'sun',
      price: '₹3,499',
      originalPrice: '₹5,999',
      discount: '42%',
      rating: 4.7,
      reviews: 850,
      description: 'UV protection polarized sunglasses',
      highlights: ['Polarized', 'UV400', 'Stylish design', 'Scratch resistant']
    },
    {
      id: 3,
      name: 'SPECIAL POWER',
      image: 'https://www.asasafety.com/cdn/shop/products/SB5610D_2_1400x1400.png?v=1621020086',
     
      count: '320+',
      iconName: 'bolt',
      price: '₹4,999',
      originalPrice: '₹7,999',
      discount: '38%',
      rating: 4.6,
      reviews: 320,
      description: 'High power prescription lenses',
      highlights: ['High index', 'Aspheric', 'Thin edges', 'Wide field']
    },
    {
      id: 4,
      name: 'CONTACT LENSES',
      image: 'https://tse3.mm.bing.net/th/id/OIP.zqNffe0GEZYSL0kjqNHfBwHaDt?rs=1&pid=ImgDetMain&o=7&rm=3',
      count: '210+',
      iconName: 'eye',
      price: '₹1,499',
      originalPrice: '₹2,499',
      discount: '40%',
      rating: 4.8,
      reviews: 210,
      description: 'Comfortable daily wear contact lenses',
      highlights: ['High oxygen', 'Moisture retention', 'UV block', 'Easy handling']
    },
    {
      id: 5,
      name: 'KIDS',
      image: 'https://www.therange.co.uk/media/4/8/1643995399_12_4553.jpg',
      count: '450+',
      iconName: 'child',
      price: '₹1,999',
      originalPrice: '₹3,499',
      discount: '43%',
      rating: 4.6,
      reviews: 450,
      description: 'Durable and stylish frames for kids',
      highlights: ['Flexible hinges', 'Safe materials', 'Bright colors', 'Impact resistant']
    },
    {
      id: 6,
      name: 'SALE',
      image: 'https://img.ebdcdn.com/product/frame/gray/pl9642_0.jpg?im=Resize,width=700,height=350,aspect=fill;UnsharpMask,sigma=1.0,gain=1.0&q=85',
      count: '70% Off',
      iconName: 'tag',
      isHot: true,
      price: '₹999',
      originalPrice: '₹3,499',
      discount: '70%',
      rating: 4.9,
      reviews: 1250,
      description: 'Limited time offer on selected frames',
      highlights: ['Clearance sale', 'Limited stock', 'Best price', 'Quick delivery']
    }
  ]), []);

  useEffect(() => {
    document.body.style.overflow = selectedCategory ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [selectedCategory]);

  const openModal = (category) => {
    setSelectedCategory(category);
    setWishlist(false);
    setActiveImage(0);
    setPincode('');
    setDeliveryChecked(false);
    setSelectedSize('M');
    setSelectedColor(0);
    setExpandedFaq(null);
  };

  const closeModal = () => setSelectedCategory(null);

  const handleBuyNow = (category) => {
    const safeProduct = {
      id: category.id,
      name: category.name,
      image: category.image,
      count: category.count,
      price: category.price,
      originalPrice: category.originalPrice,
      discount: category.discount,
      rating: category.rating,
      reviews: category.reviews,
      description: category.description,
      isHot: category.isHot || false,
    };
    navigate('/checkout', { state: { product: safeProduct } });
    closeModal();
  };

  const checkDelivery = () => {
    if (pincode.length === 6) {
      setDeliveryChecked(true);
    }
  };

  const colorOptions = ['#000000', '#8B4513', '#C0C0C0', '#FFD700', '#0000FF'];
  const sizeOptions = ['S', 'M', 'L', 'XL'];

  // Dummy data for additional sections
  const similarProducts = categories.slice(0, 4).map(c => ({ ...c, id: c.id + 100 }));
  const reviewStats = { 5: 87, 4: 11, 3: 2, 2: 0, 1: 0 };
  const userReviews = [
    { name: 'Alekhya K.', date: '25 Feb 2026', rating: 5, comment: 'I just loved 🤩 it', likes: 12, image: null },
    { name: 'Amal M.', date: '24 Feb 2026', rating: 5, comment: 'Very nice', likes: 8, image: null },
    { name: 'Hemavathy M.', date: '22 Feb 2026', rating: 5, comment: 'look and frame excellent', likes: 5, image: null },
    { name: 'Deblina R.', date: '21 Feb 2026', rating: 4, comment: 'The frame is really a statement piece...', likes: 3, image: null },
    { name: 'Manisha P.', date: '21 Feb 2026', rating: 5, comment: 'The lens and the frame is good', likes: 7, image: null },
  ];
  const faqs = [
    { q: 'What is the return policy?', a: '30-day hassle-free returns. Frame must be unused.' },
    { q: 'Do I need a prescription?', a: 'For powered lenses, yes. You can upload later.' },
    { q: 'How to clean these glasses?', a: 'Use microfiber cloth and lens cleaner.' },
  ];
  const offers = [
    '10% off on first order: NEW10',
    'No cost EMI on credit cards',
    'Free shipping on orders above ₹999'
  ];
  const warranty = '1 year manufacturer warranty';

  return (
    <>
      <section className="py-12 sm:py-16 bg-gradient-to-b from-orange-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white px-4 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 shadow-lg">
              <FaStar className="text-white text-xs animate-spin-slow" />
              <span>TOP CATEGORIES</span>
              <FaStar className="text-white text-xs animate-spin-slow" />
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-2 sm:mb-3">
              Shop by <span className="text-orange-500">Category</span>
            </h2>
            <div className="flex justify-center items-center gap-2 mb-3 sm:mb-4">
              <div className="w-10 sm:w-12 h-0.5 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
              <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
              <div className="w-10 sm:w-12 h-0.5 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
            </div>
            <p className="text-gray-500 text-xs sm:text-sm max-w-2xl mx-auto">
              Tap any category to view details
            </p>
          </div>

          {/* Category Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-6">
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => openModal(category)}
                className="group block cursor-pointer active:scale-95 transition-transform duration-150"
                onMouseEnter={() => setHoveredId(category.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div className="bg-white rounded-xl sm:rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-orange-500 transform hover:-translate-y-1 sm:hover:-translate-y-2">
                  <div className="relative h-32 sm:h-40 md:h-44 lg:h-48 overflow-hidden bg-gradient-to-br from-orange-50 to-white">
                    <div className="absolute top-2 left-2 sm:top-3 sm:left-3 z-10 w-7 h-7 sm:w-9 sm:h-9 bg-orange-100 rounded-full flex items-center justify-center border-2 border-white shadow-md group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                      <div className="text-orange-500 text-sm sm:text-lg">
                        {iconMap[category.iconName]}
                      </div>
                    </div>
                    {category.isHot && (
                      <div className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 bg-gradient-to-r from-orange-500 to-red-500 text-white text-[8px] sm:text-xs px-1.5 sm:px-3 py-0.5 sm:py-1 rounded-full flex items-center gap-1 shadow-lg animate-pulse">
                        <FaFire className="text-[8px] sm:text-xs" /> HOT
                      </div>
                    )}
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-contain p-2 sm:p-4 md:p-5 lg:p-6 transition-all duration-500 group-hover:scale-110"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = 'https://via.placeholder.com/200x150?text=' + category.name;
                      }}
                    />
                    <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 bg-white/90 backdrop-blur-sm px-1.5 sm:px-3 py-0.5 sm:py-1 rounded-full text-[8px] sm:text-xs font-semibold text-orange-600 shadow-md border border-orange-200">
                      {category.count}
                    </div>
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden sm:flex items-center justify-center">
                      <span className="bg-white text-orange-500 text-xs sm:text-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full font-semibold shadow-lg transform group-hover:scale-110 transition-transform">
                        View Details
                      </span>
                    </div>
                  </div>
                  <div className="p-2 sm:p-4 text-center border-t border-gray-100">
                    <h3 className="text-xs sm:text-base font-bold text-gray-800 mb-1 sm:mb-2 group-hover:text-orange-500 transition-colors duration-300">
                      {category.name}
                    </h3>
                    <div className={`flex items-center justify-center gap-1 text-xs sm:text-sm font-medium text-orange-500 transition-all duration-300 ${
                      hoveredId === category.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
                    } sm:opacity-100 sm:translate-y-0`}>
                      <span className="hidden sm:inline">View Details</span>
                      <FaArrowRight className="text-[10px] sm:text-xs group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RESPONSIVE PRODUCT DETAIL MODAL - TWO COLUMN ON MEDIUM+ SCREENS */}
      {selectedCategory && (
        <div
          className="fixed inset-0 z-50 bg-white overflow-y-auto"
          onClick={closeModal}
        >
          {/* Sticky Header */}
          <div className="sticky top-0 bg-white/80 backdrop-blur-md border-b border-gray-200 z-10 px-4 py-3 flex items-center justify-between">
            <button
              onClick={closeModal}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
            >
              <FaTimes size={18} />
            </button>
            <h2 className="font-semibold text-gray-800 text-base truncate max-w-[200px] md:hidden">{selectedCategory.name}</h2>
            <div className="w-9 h-9" /> {/* spacer for centering on mobile */}
            <button
              onClick={() => setWishlist(!wishlist)}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 transition md:hidden"
            >
              {wishlist ? <FaHeart className="text-red-500" size={18} /> : <FaRegHeart size={18} />}
            </button>
          </div>

          {/* Main Content - Responsive Grid */}
          <div className="px-4 md:px-6 lg:px-8 pb-24 md:pb-8" onClick={(e) => e.stopPropagation()}>
            <div className="md:grid md:grid-cols-2 md:gap-8 md:max-w-6xl md:mx-auto">
              {/* Left Column - Image Gallery */}
              <div className="md:sticky md:top-20 md:self-start">
                <div className="py-4 md:py-0">
                  <div className="relative bg-gradient-to-br from-orange-50 to-white rounded-xl flex justify-center">
                    <img
                      src={selectedCategory.images?.[activeImage] || selectedCategory.image}
                      alt={selectedCategory.name}
                      className="w-full max-h-64 md:max-h-96 object-contain"
                    />
                    {selectedCategory.isHot && (
                      <span className="absolute top-2 right-2 bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs px-3 py-1 rounded-full flex items-center gap-1 shadow">
                        <FaFire size={10} /> HOT
                      </span>
                    )}
                  </div>
                  {selectedCategory.images && selectedCategory.images.length > 1 && (
                    <div className="flex gap-2 mt-3 overflow-x-auto py-2">
                      {selectedCategory.images.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => setActiveImage(idx)}
                          className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg border-2 overflow-hidden transition ${
                            activeImage === idx ? 'border-orange-500' : 'border-gray-200 opacity-70'
                          }`}
                        >
                          <img src={img} alt={`thumb-${idx}`} className="w-full h-full object-cover" />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Right Column - Product Details */}
              <div className="py-4 md:py-0">
                {/* Title & Rating - visible on mobile, hidden on desktop (already in header) */}
                <div className="md:hidden">
                  <h1 className="text-xl font-bold text-gray-800">{selectedCategory.name}</h1>
                  <p className="text-gray-500 text-xs mt-0.5">{selectedCategory.description}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <div className="flex items-center bg-green-600 text-white px-1.5 py-0.5 rounded text-xs font-semibold">
                      {selectedCategory.rating} <FaStar className="ml-1 text-[10px]" />
                    </div>
                    <span className="text-gray-600 text-xs">{selectedCategory.reviews} Reviews</span>
                    <span className="text-gray-300 text-xs">|</span>
                    <span className="text-gray-600 text-xs">{selectedCategory.count} sold</span>
                  </div>
                </div>

                {/* Desktop Title & Rating */}
                <div className="hidden md:block mb-4">
                  <h1 className="text-2xl font-bold text-gray-800">{selectedCategory.name}</h1>
                  <p className="text-gray-500 text-sm mt-1">{selectedCategory.description}</p>
                  <div className="flex items-center gap-3 mt-3">
                    <div className="flex items-center bg-green-600 text-white px-2 py-0.5 rounded text-sm font-semibold">
                      {selectedCategory.rating} <FaStar className="ml-1 text-xs" />
                    </div>
                    <span className="text-gray-600 text-sm">{selectedCategory.reviews} Reviews</span>
                    <span className="text-gray-300">|</span>
                    <span className="text-gray-600 text-sm">{selectedCategory.count} sold</span>
                  </div>
                </div>

                {/* Price Row */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="flex items-baseline gap-2">
                    <span className="text-2xl md:text-3xl font-bold text-gray-900">{selectedCategory.price}</span>
                    <span className="text-gray-400 line-through text-xs md:text-sm">{selectedCategory.originalPrice}</span>
                    <span className="bg-orange-100 text-orange-600 text-[10px] md:text-xs font-semibold px-2 py-0.5 rounded-full">{selectedCategory.discount} OFF</span>
                  </div>
                </div>

                {/* Action Buttons - content-based width, centered on desktop */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="flex flex-wrap justify-center sm:justify-start gap-3">
                    <button className="bg-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold flex items-center justify-center gap-2 text-sm hover:bg-orange-600 transition">
                      <FaShoppingCart size={14} /> ADD TO CART
                    </button>
                    <button
                      onClick={() => handleBuyNow(selectedCategory)}
                      className="bg-black text-white px-5 py-2.5 rounded-lg font-semibold flex items-center justify-center gap-2 text-sm border border-orange-500 hover:bg-gray-900 transition"
                    >
                      <FaCreditCard size={14} /> BUY NOW
                    </button>
                  </div>
                </div>

                {/* Offers Row */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaGift className="text-orange-500" size={16} /> Offers</h3>
                  <div className="space-y-1.5">
                    {offers.map((offer, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-xs md:text-sm">
                        <FaPercentage className="text-green-500 flex-shrink-0" size={12} />
                        <span className="text-gray-700">{offer}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Feature Buttons */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="grid grid-cols-3 gap-2">
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaStore className="text-orange-500 text-lg md:text-xl mb-1" />
                      Stores
                    </button>
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaCube className="text-orange-500 text-lg md:text-xl mb-1" />
                      360°
                    </button>
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaRegEye className="text-orange-500 text-lg md:text-xl mb-1" />
                      Try On
                    </button>
                  </div>
                </div>

                {/* Similar Products (horizontal scroll) */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><span className="w-1 h-4 bg-orange-500 rounded-full"></span>Similar Products</h3>
                  <div className="flex gap-2 overflow-x-auto pb-2">
                    {similarProducts.map((prod) => (
                      <div key={prod.id} className="flex-shrink-0 w-28 md:w-32 bg-white border border-gray-200 rounded-lg p-2">
                        <img src={prod.image} alt={prod.name} className="w-full h-14 md:h-16 object-contain" />
                        <p className="text-[10px] md:text-xs font-medium mt-1 truncate">{prod.name}</p>
                        <div className="flex items-center text-[9px] md:text-[10px] mt-0.5">
                          <FaStar className="text-yellow-400 mr-0.5" size={8} /> {prod.rating}
                        </div>
                        <p className="text-orange-600 font-bold text-xs md:text-sm mt-0.5">{prod.price}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Delivery */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaTruck className="text-orange-500" size={16} /> Delivery</h3>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Pincode"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value.replace(/\D/g, '').slice(0,6))}
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm focus:ring-1 focus:ring-orange-200 outline-none"
                    />
                    <button
                      onClick={checkDelivery}
                      className="bg-orange-500 text-white px-4 py-2 rounded-lg text-xs md:text-sm font-medium hover:bg-orange-600 transition"
                    >
                      Check
                    </button>
                  </div>
                  {deliveryChecked && (
                    <p className="text-green-600 text-[10px] md:text-xs mt-1.5 flex items-center gap-1"><FaCheckCircle size={10} /> Express delivery available</p>
                  )}
                </div>

                {/* Color & Size */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2">Frame Color</h3>
                  <div className="flex gap-2">
                    {colorOptions.map((color, idx) => (
                      <button
                        key={idx}
                        onClick={() => setSelectedColor(idx)}
                        className={`w-7 h-7 md:w-8 md:h-8 rounded-full border-2 transition-all ${selectedColor === idx ? 'border-orange-500 scale-110' : 'border-gray-300'}`}
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mt-4 mb-2">Frame Size</h3>
                  <div className="flex gap-1.5">
                    {sizeOptions.map((size) => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`px-3 py-1.5 md:px-4 md:py-2 rounded-lg border text-xs md:text-sm font-medium transition ${
                          selectedSize === size ? 'bg-orange-500 text-white border-orange-500' : 'bg-white border-gray-300 text-gray-700'
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Highlights */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaCheckCircle className="text-orange-500" size={16} /> Highlights</h3>
                  <div className="grid grid-cols-2 gap-2">
                    {selectedCategory.highlights?.map((hl, idx) => (
                      <div key={idx} className="flex items-center gap-1.5 bg-orange-50 p-2 rounded-lg">
                        <FaCheckCircle className="text-orange-500 text-xs flex-shrink-0" />
                        <span className="text-[10px] md:text-xs text-gray-700">{hl}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* EMI / Warranty */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaRupeeSign className="text-orange-500" size={16} /> EMI & Warranty</h3>
                  <div className="flex items-center gap-2 text-xs md:text-sm text-gray-700">
                    <FaShieldAlt className="text-green-500" size={14} />
                    <span>{warranty}</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs md:text-sm text-gray-700 mt-1">
                    <FaExchangeAlt className="text-blue-500" size={14} />
                    <span>7-day replacement</span>
                  </div>
                </div>

                {/* Rating & Reviews */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2">Reviews</h3>
                  <div className="flex items-center gap-3">
                    <div className="text-center">
                      <span className="text-3xl md:text-4xl font-bold text-gray-900">{selectedCategory.rating}</span>
                      <div className="flex text-yellow-400 mt-0.5">
                        {[...Array(5)].map((_, i) => (
                          i < Math.floor(selectedCategory.rating) ? <FaStar key={i} size={12} /> : 
                          i < selectedCategory.rating ? <FaStarHalfAlt key={i} size={12} /> : <FaStar key={i} className="text-gray-300" size={12} />
                        ))}
                      </div>
                      <span className="text-[9px] md:text-xs text-gray-500">{selectedCategory.reviews} reviews</span>
                    </div>
                    <div className="flex-1 space-y-0.5">
                      {[5,4,3,2,1].map((star) => (
                        <div key={star} className="flex items-center gap-1 text-[9px] md:text-xs">
                          <span>{star}</span>
                          <FaStar className="text-yellow-400" size={8} />
                          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                            <div className="h-full bg-orange-500" style={{ width: `${reviewStats[star]}%` }}></div>
                          </div>
                          <span className="text-gray-500 w-4 text-right">{reviewStats[star]}%</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* User Photos */}
                  <div className="mt-4">
                    <p className="text-xs md:text-sm font-medium mb-2 flex items-center gap-1"><FaCamera className="text-orange-500" size={12} /> User Photos ⸱ 10</p>
                    <div className="flex gap-1 overflow-x-auto pb-1">
                      {[...Array(8)].map((_, i) => (
                        <div key={i} className="w-12 h-12 md:w-14 md:h-14 bg-gray-200 rounded-lg flex-shrink-0 flex items-center justify-center text-gray-400">
                          <FaCamera size={14} />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Reviews List */}
                  <div className="mt-4 space-y-3">
                    {(showFullReviews ? userReviews : userReviews.slice(0,2)).map((rev, idx) => (
                      <div key={idx} className="border-b border-gray-100 pb-2 last:border-0">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-1.5">
                            <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center text-orange-600"><FaUser size={10} /></div>
                            <span className="font-medium text-xs md:text-sm">{rev.name}</span>
                          </div>
                          <span className="text-[9px] md:text-xs text-gray-400">{rev.date}</span>
                        </div>
                        <div className="flex text-yellow-400 text-[9px] md:text-xs mt-0.5">
                          {[...Array(5)].map((_, i) => <FaStar key={i} className={i < rev.rating ? 'text-yellow-400' : 'text-gray-300'} size={10} />)}
                        </div>
                        <p className="text-[10px] md:text-xs mt-0.5">{rev.comment}</p>
                      </div>
                    ))}
                    {userReviews.length > 2 && (
                      <button
                        onClick={() => setShowFullReviews(!showFullReviews)}
                        className="text-orange-500 text-[10px] md:text-xs font-medium mt-1 w-full text-center py-2 border border-orange-200 rounded-lg hover:bg-orange-50 transition"
                      >
                        {showFullReviews ? 'Show less' : 'Read All Reviews'}
                      </button>
                    )}
                  </div>
                </div>

                {/* FAQs */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaQuestionCircle className="text-orange-500" size={16} /> FAQs</h3>
                  <div className="space-y-1.5">
                    {faqs.map((faq, idx) => (
                      <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden">
                        <button
                          onClick={() => setExpandedFaq(expandedFaq === idx ? null : idx)}
                          className="w-full flex justify-between items-center p-2 md:p-3 text-left bg-gray-50 hover:bg-gray-100 transition"
                        >
                          <span className="text-xs md:text-sm font-medium">{faq.q}</span>
                          {expandedFaq === idx ? <FaChevronUp className="text-orange-500" size={12} /> : <FaChevronDown className="text-gray-400" size={12} />}
                        </button>
                        {expandedFaq === idx && (
                          <div className="p-2 md:p-3 text-[10px] md:text-xs text-gray-600 border-t border-gray-200 bg-white">
                            {faq.a}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Product Details */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Product Details</h3>
                  <p className="text-[10px] md:text-xs text-gray-600 mb-2">{selectedCategory.description}</p>
                  <table className="w-full text-[10px] md:text-xs">
                    <tbody>
                      <tr><td className="py-1 text-gray-500">Material</td><td className="font-medium text-right">Acetate</td></tr>
                      <tr><td className="py-1 text-gray-500">Hinge</td><td className="font-medium text-right">Spring</td></tr>
                      <tr><td className="py-1 text-gray-500">Temple</td><td className="font-medium text-right">45mm</td></tr>
                      <tr><td className="py-1 text-gray-500">Nosepad</td><td className="font-medium text-right">Adjustable</td></tr>
                    </tbody>
                  </table>
                </div>

                {/* Shop by Looks */}
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Shop by Looks</h3>
                  <div className="flex flex-wrap gap-1">
                    {['Chic & Glam', 'Comfy & Classy', 'Make Impact', 'Street Style'].map((look, i) => (
                      <span key={i} className="bg-orange-50 px-2 py-1 rounded-full text-[9px] md:text-xs text-orange-700 font-medium">#{look.toLowerCase().replace(/ /g,'')}</span>
                    ))}
                  </div>
                </div>

                {/* Recently Viewed */}
                <div className="py-3">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Recently Viewed</h3>
                  <div className="flex gap-2 overflow-x-auto pb-1">
                    {categories.slice(0,3).map((prod) => (
                      <div key={prod.id} className="flex-shrink-0 w-20 md:w-24 text-center">
                        <img src={prod.image} alt={prod.name} className="w-full h-12 md:h-14 object-contain border border-gray-200 rounded-lg p-1" />
                        <p className="text-[9px] md:text-xs mt-0.5 truncate">{prod.name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Bottom Bar - only on mobile */}
          <div className="sticky bottom-0 bg-white/80 backdrop-blur-md border-t border-gray-200 p-3 md:hidden">
            <div className="flex justify-between items-center gap-2 max-w-xs mx-auto">
              <button className="bg-orange-500 text-white px-6 py-2 rounded-lg font-semibold text-xs flex items-center justify-center gap-1 hover:bg-orange-600 transition">
                <FaShoppingCart size={12} /> ADD
              </button>
              <button
                onClick={() => handleBuyNow(selectedCategory)}
                className="bg-black text-white px-6 py-2 rounded-lg font-semibold text-xs flex items-center justify-center gap-1 hover:bg-gray-900 transition border border-orange-500"
              >
                <FaCreditCard size={12} /> BUY
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .animate-spin-slow { animation: spin-slow 3s linear infinite; }
      `}</style>
    </>
  );
};

export default TopCategories;